/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactSortCriteria {
    getFixupPrototypeFunction() { return ArtifactSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ArtifactSortCriteria>): ArtifactSortCriteria {
        let obj = Object.assign(new ArtifactSortCriteria(), model);
        ArtifactSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactSortCriteria>): ArtifactSortCriteria {
        if (!model) return null;
        return ArtifactSortCriteria.newInstance(<ArtifactSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactSortCriteria) {
        if (!obj) return;

        models.ArtifactSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactSortCriteria): boolean {
        Object.setPrototypeOf(obj, ArtifactSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ArtifactSortColumn;

    ascending: boolean;

}
